/**
* AI写作-文章
**/ 

<template>
    
  <div class="ai-article">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <!-- <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item> -->
      <el-breadcrumb-item >文章库</el-breadcrumb-item>
      <!-- <el-breadcrumb-item v-if="detailShow">详情</el-breadcrumb-item> -->
    </el-breadcrumb>
    <el-card class="box-card">
      <!-- 标题列表 s -->
      <div class="box-table">

        <!-- 搜索筛选 -->
        <el-form :inline="true" :model="formInline"  :size="size" ref="ruleForm0">
          <el-form-item  prop="keyword">
            <el-input placeholder="" v-model="keyword">
                <el-select slot="prepend" :size="size" style="width:80px" v-model="index"  >
                    <el-option :label="'标题'" :value="0"> </el-option>
                    <el-option :label="'关键词'" :value="1"> </el-option>
                </el-select>
            </el-input>
          </el-form-item>
          <el-form-item  prop="configId">
            <el-select  style="width:100%" v-model="formInline.configId"  placeholder="站点">
              <el-option v-for="item in configList" :key="item.id" :label="item.domain" :value="item.id"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item  prop="state">
            <el-select   style="width:100%" v-model="formInline.state" placeholder="状态" >
                <!-- <el-option :label="'可发布'" :value="0"> </el-option> -->
                <el-option :label="'待发布'" :value="0"> </el-option>
                <el-option :label="'已发布'" :value="1"> </el-option>
                <el-option :label="'发布失败'" :value="-1"> </el-option>
                <el-option :label="'终止'" :value="2"> </el-option>
                <el-option :label="'暂停'" :value="3"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button :size="size"  icon="el-icon-search" @click="search">搜索</el-button>
            <el-button :size="size" @click="resetForm('ruleForm0')">重置</el-button>
            <el-button :size="size" type="warning" plain icon="el-icon-s-promotion" @click="createArticleHandler()">手动生成文章</el-button>
          </el-form-item>
        </el-form>
        <!-- <el-row :gutter="20" style="margin-top:10px">
            <el-col :span="2.5">
                <div class="grid-content bg-purple">
                    <el-button :size="size" type="success" plain icon="el-icon-plus" @click="addHandler">批量生成文章</el-button>
                </div>
            </el-col>
            <el-col :span="2.5">
                <div class="grid-content bg-purple">
                    <el-button :size="size" type="danger" plain icon="el-icon-s-promotion" @click="publishHandler('auto')">添加自动发布任务</el-button>
                </div>
            </el-col>
            <el-col :span="2.5">
                <div class="grid-content bg-purple">
                    <el-button :size="size" type="warning" plain icon="el-icon-s-promotion" @click="publishHandler('manual')">手动发布任务</el-button>
                </div>
            </el-col>
            <el-col :span="2.5">
                <div class="grid-content bg-purple">
                    <el-button :size="size" type="primary" plain icon="el-icon-top">重新发布</el-button>
                </div>
            </el-col>
        </el-row> -->
        <!--列表-->
        <el-table size="small" ref="multipleTable" tooltip-effect="dark" :data="listData" highlight-current-row v-loading="loading" element-loading-text="拼命加载中" style="width: 100%;margin-top:20px">
           <!-- <el-table-column  type="selection" width="55"> </el-table-column> -->
          <el-table-column sortable  prop="id" label="编号" >
          </el-table-column>
          <el-table-column sortable prop="keyword" label="关键词" show-overflow-tooltip>
          </el-table-column>
          <el-table-column sortable prop="title" label="标题" show-overflow-tooltip>
          </el-table-column>
          <el-table-column sortable prop="state" label="状态">
            <template slot-scope="scope">
              <span>{{scope.row.state | state}}</span>
            </template>
          </el-table-column>
          <!-- <el-table-column sortable prop="tag" label="标签" show-overflow-tooltip>
          </el-table-column> -->
          <el-table-column sortable prop="createTime" label="创建时间" >
            <template slot-scope="scope">
              <div>{{scope.row.createTime|timestampToTime}}</div>
            </template>
          </el-table-column>
          <el-table-column sortable prop="name" label="发布任务" show-overflow-tooltip>
          </el-table-column>
          <el-table-column align="center" label="操作">
            <template  slot-scope="scope">
              <el-button type="text" size="mini" @click="openDetail(scope.row)">详情</el-button>
                <el-popconfirm
                  title="您去确定要删除这篇文章吗？"
                  @confirm="delHandler(scope.row.id)"
                  v-if="scope.row.state==0||scope.row.state==3||scope.row.state==-1"
                >
                  <el-button type="text" slot="reference" size="mini" >删除</el-button>
                </el-popconfirm>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页组件 -->
        <Pagination style="float:right" v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>

      </div>
      <!-- 列表 e -->
    </el-card>
    <!-- 添加标题 -->
    <!-- <el-dialog
        title="批量添加"
        :visible.sync="addDialogVisible"
        width="50%"
        :destroy-on-close="!closeOnClickModal"
        :close-on-click-modal="closeOnClickModal">
        <el-form  :model="temp" :rules="rules" ref="ruleForm">
            <el-form-item label="任务标签(文章生成归类类别)" prop="tag">
                <el-input v-model="temp.tag" placeholder=""></el-input>
            </el-form-item>
            <el-form-item label="关键词或标题列表(一行一个)" prop="keyword">
                <el-input
                    type="textarea"
                    :autosize="{ minRows: 5, maxRows: 10}"
                    placeholder=""
                    v-model="temp.keyword">
                </el-input>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="addDialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="addFun">确 定</el-button>
        </span>
    </el-dialog> -->
    
    <!-- 文章详情 -->
    <el-dialog
    top="15px"
        title="文章内容"
        :visible.sync="detailDialogVisible"
        width="80%"
        :destroy-on-close="!closeOnClickModal"
        :close-on-click-modal="closeOnClickModal">
        
        <el-form  :model="temp" :rules="rules2" ref="ruleForm2" label-width="100px">
            <el-form-item label="标题" prop="title">
                <el-input v-model="temp.title" placeholder="" :style="(temp.state==0||temp.state==3)?'font-size: 16px;width: 85%':'font-size: 16px;'"></el-input>
                <el-button v-if="temp.state==0||temp.state==3" style="background: #63c7e7;color: white;"   @click="createContent(1)" :loading="loadingTitle">重新生成标题</el-button>
            </el-form-item>
            <el-form-item label="关键词" prop="keyword">
                <el-input v-model="temp.keyword" placeholder="" style="font-size: 16px"></el-input>
            </el-form-item>
            <el-form-item label="正文" prop="content">
                <quill-editor v-loading="loadingArticle2" style="white-space: pre-line;font-size: large;" v-maxWindow v-model="temp.content" ref="myQuillEditor" :options="editorOption" @blur="onEditorBlur($event)" @focus="onEditorFocus($event)" @change="onEditorChange($event)">
                </quill-editor>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button style="background: #63c7e7;color: white;" @click="createContent(2)"  v-if="temp.state==0||temp.state==3">重新生成正文</el-button>
            <el-button type="success" @click="copyHandler(1)">复制html</el-button>
            <el-button type="warning" @click="copyHandler(2)">复制文本</el-button>
            <el-button type="primary" @click="submitFun"  v-if="temp.state==0||temp.state==3" >修改</el-button>
            <el-button @click="detailDialogVisible = false">关闭</el-button>
        </span>
    </el-dialog>
    
    <!-- 手动生成文章 -->
    <el-dialog
        title="文章生成"
        :visible.sync="configDialogVisible"
        width="30%"
        :close-on-click-modal="closeOnClickModal">
        <el-form  :model="createArticleData" :rules="form3rules" ref="ruleForm3">
            <el-form-item label="操作数量" prop="count">
                <el-input-number :size="size" v-model="createArticleData.count" style="width:100%" :min="1"></el-input-number>
                <!-- <el-tag :size="size" type="info" v-if="createArticleData.task.totalCount">您选择的任务可发布文章数量为：{{createArticleData.task.totalCount-createArticleData.task.completeCount}}</el-tag> -->
            </el-form-item>
            <el-form-item label="选择任务" prop="configId">
                <el-select :size="size" clearable style="width:100%" 
                 v-model="createArticleData.configId" 
                 filterable placeholder="请选择"
                 @change="taskChange"
                 >
                  <el-option
                  v-for="(item, index) in taskList" :key="index" :label="item.name" :value="item.id">
                  </el-option>
                </el-select>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="configDialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="createArticleBatch">确 定</el-button>
        </span>
    </el-dialog>
  </div>
</template>

<script>
// 导入组件
import Pagination from '@/components/Pagination'
import moment from 'moment'
import { getArticleList,getArticle,modifyArticle,getConfig,createTitle,createArticle, delArticle,getPublish,addArticleBatch} from '@/api/basisMG' 
//实体类
import { AiArticle } from '@/module/entity' 
// 导出模块
export default {
  // 模块名字
  name: "aiArticle",
  // 模块数据
  data() {
    
    let validateHandler = (rule,value,callback) => {
        // 输入的值不能大于所选任务可发布文章的数（任务文章总数量-已完成数量=可发布文章数量）
        const num  = this.createArticleData.task.totalCount-this.createArticleData.task.completeCount
        if(value>num){
          callback(new Error('生成文章数量不可大于所选任务的可发布文章数'))
        }else{
          callback()
        }
      
    }
    //数据  
    return {
      addDialogVisible: false, //添加对话框显示
      detailDialogVisible: false, //详情对话框显示
      configDialogVisible: false, //详情对话框显示
      closeOnClickModal: false, //是否可以通过点击 modal 关闭 Dialog
      loading: false,
      loadingTitle: false, //访问openai时的loading
      loadingArticle2: false, //访问openai时的loading
      size: 'small',
      index: 0,
      keyword:'',
      formInline: {
        page: 1,
        pageSize: 10,
        keyword: '',
        title: '',
        configId: null,
        state: 0
      },
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      listData:[],
      temp: new AiArticle,
      rules: {
          tag: [
            { required: true, message: '请输入标签', trigger: 'blur' }
          ],
          keyword: [
            { required: true, message: '请输入关键词', trigger: 'blur' }
          ],
        },
      rules2: {
        title: [
          { required: true, message: '请输入标题', trigger: 'blur' }
        ],
        keyword: [
          { required: true, message: '请输入关键词', trigger: 'blur' }
        ],
        content: [
          { required: true, message: '请输入文章内容', trigger: 'blur' }
        ],
      },
      titleArray: [],
      editorOption: {
        placeholder: '',
        modules: {
          toolbar: [
          ]
        }
      },
      configList:[],
      createArticleData: {
        configId: null,
        count: 1,
        task: {}
      },
      form3rules: {
          configId: [
            { required: true, message: '请选择任务', trigger: 'blur' }
          ],
          count: [
            { validator :  validateHandler, trigger: 'blur' }
          ],
      },
      publishType: null,
      taskList: []
    };
  },
  // 注册组件
  components: {
    Pagination
  },
  // 监听指定值，只有指定值变化，才会触发
  watch: {},
  // 里面的函数只有调用才会执行（实时计算）里面是定义的方法
  methods: {
    // 重新生成标题/文章内容
    createContent(index) {
      if(index==1){
        this.loadingTitle = true
        createTitle(this.temp.id).then(res=>{
          this.loadingTitle = false
          if(res.code===0){
            this.temp.title = res.data
          }
        })
      }else if(index==2){
        const params = {
          title: this.temp.title
        }
        this.loadingArticle2 = true
        createArticle(this.temp.id,params).then(res=>{
          this.loadingArticle2 = false
          if(res.code===0){
            this.$message.success('文章生成中，请稍等片刻后重新查看')
          }
        })
      }
    },
    // 修改文章
    submitFun() {
      const params = {
        title: this.temp.title,
        keyword: this.temp.keyword,
        content: this.temp.content
      }
      modifyArticle(this.temp.id,params).then(res=>{
        if(res.code===0){
          this.detailDialogVisible=false
          this.$message.success('修改成功')
          this.getdata(this.formInline)
        }else{
          this.$message.error(res.message)
        }
      })
    },
    // 获取文章列表
    getdata(parameter) {
        if(this.index===0){
          parameter.title = this.keyword
          parameter.keyword = null
        }else if(this.index===1){
          parameter.keyword = this.keyword
          parameter.title = null
        }
        const params={
            title: parameter.title,
            keyword: parameter.keyword,
            state: parameter.state,
            configId: parameter.configId,
            page: parameter.page,
            pageSize: parameter.pageSize
        }
        getArticleList(params)
            .then(res => {
            this.loading = false
            if (res.code == 0) {
                this.listData = res.data
                // 分页赋值
                this.pageparm.currentPage = this.formInline.page
                this.pageparm.pageSize = this.formInline.pageSize
                this.pageparm.total = res.totalCount
            } else {
                this.$message({
                type: 'error',
                message: res.message
                })
            }
        })
    },
    search(){
        this.getdata(this.formInline)
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.pageSize = parm.pageSize
      this.getdata(this.formInline)
    },
    // 文章详情
    openDetail(row){
        this.detailDialogVisible=true
        getArticle(row.id).then(res=>{
          if(res.code===0){
            this.temp = res.data
            this.temp.content = res.data.content.replace(/\\n/g, '\n')
          }
        })
    },
    // 添加文章按钮点击
    createArticleHandler(){
      this.configDialogVisible = true

    },
    // 重置查询条件
    resetForm(formName) {
      this.index = 0
      this.keyword = ''
      this.$refs[formName].resetFields();
      this.search()
    },
    // 复制操作
    copyHandler(index){
      let context = "";
      if(index===1){
        console.log(this.$refs.myQuillEditor.quill.root.innerHTML)
        context = this.$refs.myQuillEditor.quill.root.innerHTML
      }else{
        console.log(this.$refs.myQuillEditor.quill.getText())
        context = this.$refs.myQuillEditor.quill.getText()
      }
      var _this = this
      this.$copyText(context).then(
        function(e) {
          _this.onCopy()
        },
        function(e) {
          _this.onError()
        }
      )
    },
    // 复制乘公共
    onCopy(){
      this.$message({ type: 'success', message: '复制成功' });
      this.showShare = false
    },
    // 复制失败
    onError(){
      this.$message({ type: 'warning', message: '复制失败' });
    },
    // 获取发布配置
    getConfigData(){
        getConfig({page:1, pageSize: 100}).then(res => {
            if (res.code == 0) {
                this.configList = res.data
            } 
        })
    },
    // 删除文章
    delHandler(id){
      delArticle(id).then(res=>{
          if(res.code===0){
            this.$message.success('删除成功')
            this.getdata(this.formInline)
          }else{
            this.$message.error(res.message)
          }
      })
    },
    // 切换发布任务时
    taskChange(item){
      console.log(item)
      this.createArticleData.task = item
    },
    // 获取手动发布任务列表
    getTaskList(parameter) {
        const params={
            state: 0,
            page: 1,
            pageSize: 10000,
            mode: 1
        }
        getPublish(params).then(res => {
            if (res.code == 0) {
                this.taskList = res.data
            }else{
              console.log(res.message)
            }
        })
    },
    // 批量生成文章
    createArticleBatch(){
      this.$refs['ruleForm3'].validate(valid => {
            console.log(valid)
            if(valid){
              let params={
                atsId: this.createArticleData.configId,
                count: this.createArticleData.count
              }
              addArticleBatch(params).then(res=>{
                if(res.code===0){
                  this.$message.success('文章生成中，请稍等片刻后重新查看')
                }else{
                  this.$message.error('文章生成失败')
                  console.log(res.message)
                }
              })
            }
        })
    }
  },
  filters: {
    timestampToTime(value) {
      return moment(value).format('YYYY-MM-DD HH:mm:SS')
    },
    state(num) {
      switch (num) {
        case 0:
          return '待发布'
        case -1:
          return '发布失败'
        case 1:
          return '已发布'
        case 2:
          return '终止'
        case 3:
          return '暂停'
        default:
          return ''
      }
    },
  },
  // 创建前状态(里面是操作)
  beforeCreate() {},
  // 创建完毕状态(里面是操作)
  created() {},
  // 挂载前状态(里面是操作)
  beforeMount() {},
  // 挂载结束状态(里面是操作)
  mounted() {
    this.getdata(this.formInline)
    this.getConfigData()
    this.getTaskList()
  },
  // 更新前状态(里面是操作)
  beforeUpdate() {},
  // 更新完成状态(里面是操作)
  updated() {},
  // 销毁前状态(里面是操作)
  beforeDestroy() {},
  // 销毁完成状态(里面是操作)
  destroyed() {}
};
</script>
// scoped 样式只在本组件使用
<style>
/**
 * 导入css样式组件
 * @import "../assets/css/components/index.css";
 */
 .ai-article .ql-editor {
    font-size: 16px;
 }
 .ai-article .el-form-item__label {
    font-size: 16px;
 }
 .ai-article .ql-editor p{
    margin: 10px 0;
    line-height: 1.5;
 }
</style>



// WEBPACK FOOTER //
// src/views/ai/writer/article.vue